import { CourseCategoryPage } from '@/components/seo/CourseCategoryPage';

export default function DigitalMarketingPage() {
  return (
    <CourseCategoryPage
      config={{
        title: 'שיווק דיגיטלי – מה לבדוק לפני קורס',
        metaTitle: 'קורס שיווק דיגיטלי 2025 – PPC, SEO, Social, Analytics | Kursi',
        slug: 'digital-marketing',
        metaDescription: 'קורסי שיווק דיגיטלי 2025 – PPC, SEO, Social Media, Analytics. מדריך מקצועי לבחירת קורס שיווק דיגיטלי עם תרגול אמיתי. קבלו 3 המלצות קורסים אישיות.',
        subtitle:
          'שיווק דיגיטלי הוא מקצוע פרקטי. אם אין תרגול על קמפיינים, מדידה ותוצרים — זה לרוב קורס תיאורטי שלא שווה כסף.',
        chips: ['PPC', 'SEO', 'מדידה', 'תוצרים'],
        chatSeed: 'קורס שיווק דיגיטלי',
        sections: [
          {
            id: 'paths',
            title: 'בחר התמחות',
            body:
              '“שיווק דיגיטלי” זה מטרייה. תבחר כיוון: PPC, SEO, Social, CRO, Content. קורס טוב לא מבלבל אותך עם הכול.',
            bullets: ['PPC (Meta/Google)', 'SEO + תוכן', 'Social + קריאייטיב', 'Analytics + CRO'],
          },
          {
            id: 'measurement',
            title: 'מדידה – חובה',
            body:
              'אם לא יודעים למדוד, אי אפשר לדעת מה עובד. קורס טוב נוגע ב-GA4, Events, פיקסלים ו-KPI.',
            bullets: ['GA4 בסיסי', 'אירועים (Events)', 'קריאת דוחות + החלטות'],
          },
          {
            id: 'deliverables',
            title: 'תוצרים אמיתיים',
            body:
              'בסוף קורס טוב אתה יוצא עם תיק עבודות: קמפיין לדוגמה, דוח ביצועים, ותהליך עבודה מסודר.',
            bullets: ['מבנה קמפיין', 'קריאייטיב + קופי', 'דוח KPI', 'תהליך אופטימיזציה'],
          },
        ],
        checklist: [
          'יש תרגול על פלטפורמות (או סימולציה רצינית)',
          'יש מדידה (GA4/Events) לפחות ברמה בסיסית',
          'יש תוצרים: קמפיין + דוח + KPI',
          'יש שיטה לתהליך עבודה ולא “טריקים”',
          'יש ליווי/משוב על משימות',
        ],
        redFlags: [
          '“סודות” במקום שיטה',
          'אין תרגול בכלל',
          'הכל כללי בלי התמחות',
          'אין תוצרים בולטים',
        ],
        faq: [
          { q: 'מה יותר חשוב: SEO או PPC?', a: 'PPC מביא תוצאות מהר, SEO נבנה לאורך זמן. תלוי מטרה ותקציב.' },
          { q: 'צריך ידע קודם?', a: 'לא חובה, אבל קורס טוב יתחיל מבסיס וייתן תרגול ולא רק תיאוריה.' },
        ],
      }}
    />
  );
}
